import { CircularProgress, Popover, Typography } from "@mui/material";
import Notify from "./notify";
import { useNavigate } from "react-router-dom";
import { ApiService, EmptyState, useApiQuery, useUserInfo } from "../utilities";

const NotificationPopover = ({ anchorEl, open, onClose }) => {
  const navigate = useNavigate();
const { userId: userID } = useUserInfo();

  const { data, isLoading: notificationsLoading } = useApiQuery(
    ['notifications-popover', userID],
    ApiService.getNotifications,
    { userID, limit: 4, page: 1 },
    { enabled: !!userID }
  );

  const notifications = data?.notifications || [];

  const handleNotification = () => {
    navigate(`/notifications`);
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        "& .MuiPaper-root": {
          width: "360px",
          height: "450px"
        },
      }}
    >
      <div className="px-6 mt-6 flex justify-between items-center w-full">
        <Typography fontSize={18} fontWeight={600} color={"#141B23"}>
          Notifications
        </Typography>
        <Typography fontSize={12} fontWeight={700} onClick={handleNotification} className="cursor-pointer text-primary-blue">
          View All
        </Typography>
      </div>
      {notificationsLoading ? <div className="flex justify-center h-3/4 items-center"><CircularProgress /></div> : !notifications?.length ? <EmptyState height={'40vh'} /> :
        notifications?.length ? notifications?.map((item, index) => (
          <Notify
            key={index}
            name={item.name}
            text={item?.body}
            time={item.time}
            date={item?.createdOn}
            view={item.view}
            ad={item.ad}
          />
        )) : <EmptyState />
      }
    </Popover>
  );
};

export default NotificationPopover;
